import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { VrEvent } from '../models/vr-events/VrEvent';
import { NgForm } from '@angular/forms';
import { EventType } from '../models/vr-events/EventType';
import { EventTrigger } from '../models/vr-events/EventTrigger';
import { MovementEvent } from '../models/vr-events/MovementEvent';
import { API_SETTINGS } from './API_SETTINGS';
import { VrEventAssetRelation } from '../models/vr-events/VrEventAssetRelation';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'VrEventAssetRelation';

@Injectable({
  providedIn: 'root'
})
export class ApiVrEventAssetRelationService {
  

  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getVrEventAssetRelationsWithSceneAssetRelationId(id: number): Observable<VrEventAssetRelation[]> {
    const url = `${apiUrl}/GetVrEventAssetRelationsWithSceneAssetRelationId/${id}`;
    return this.http.get<VrEventAssetRelation[]>(url).pipe();
  }

  

  addVrEventAssetRelation(relation: VrEventAssetRelation): Observable<VrEventAssetRelation>{  
    const url = apiUrl +'/PostVrEventAssetRelation'
    return this.http.post<VrEventAssetRelation>(url, relation, httpOptions).pipe();
  }


}
